<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="cancel">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="跟进时间" hasFeedback>
              <a-date-picker
                :disabled="!isEdit"
                class="itemWidth"
                @change="changTime"
                placeholder="请选择跟进时间"
                v-decorator="['traceTime', { rules: [{ required: true, message: '请选择跟进时间！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="进展情况" hasFeedback>
              <a-textarea
                placeholder="请输入进展情况"
                id="info"
                :disabled="!isEdit"
                v-decorator="['info', { rules: [{ required: true, message: '请输入进展情况！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="需要协调信息" hasFeedback>
              <a-textarea
                placeholder="请输入需要协调信息"
                id="remark"
                :disabled="!isEdit"
                v-decorator="['remark', { rules: [{ required: true, message: '请输入需要协调信息！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="跟进状态" hasFeedback>
              <a-select
                :allowClear="true"
                placeholder="请选择跟进状态"
                class="itemWidth"
                :disabled="!isEdit"
                @change="changStatus"
                v-decorator="['status', { rules: [{ required: true, message: '请选择跟进状态！' }] }]"
              >
                <a-select-option
                  v-for="(item,index) in statusList"
                  :key="index"
                  :value="item.code"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <div v-if="isStatus === 'MARKET_STATUS_02'">
            <div v-if="type === 'MODAL_ADD' ">
              <a-col :span="11">
                <a-form-item
                  :labelCol="labelCol2"
                  :wrapperCol="wrapperCol2"
                  label="开标日期"
                  hasFeedback
                >
                  <a-date-picker
                    :disabled="!isEdit"
                    class="itemWidth"
                    @change="changTime"
                    placeholder="请选择开标日期"
                    v-decorator="['openingTime', { rules: [{ required: true, message: '请选择开标日期！' }] }]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="中标金额">
                  <a-input
                    placeholder="请输入中标金额"
                    autocomplete="off"
                    addon-after="元"
                    :disabled="!isEdit"
                    v-decorator="['winningPrice', { rules: [{ required: true, message: '请输入中标金额！' }] }]"
                  />
                </a-form-item>
              </a-col>
            </div>
            <div v-if="type === 'MODAL_MODIFY'">
              <a-col :span="11">
                <a-form-item
                  :labelCol="labelCol2"
                  :wrapperCol="wrapperCol2"
                  label="中标日期"
                  hasFeedback
                >
                  <a-date-picker
                    :disabled="!isEdit"
                    class="itemWidth"
                    @change="changTime"
                    placeholder="请选择中标日期"
                    v-decorator="['winningTime', { rules: [{ required: true, message: '请选择中标日期！' }] }]"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="投标金额">
                  <a-input
                    placeholder="请输入投标金额"
                    autocomplete="off"
                    addon-after="元"
                    :disabled="!isEdit"
                    v-decorator="['tenderPrice', { rules: [{ required: true, message: '请输入投标金额！' }] }]"
                  />
                </a-form-item>
              </a-col>
            </div>
          </div>
          <div v-if="isStatus === 'MARKET_STATUS_03'">
            <div v-if="type === 'MODAL_ADD' ">
              <a-col :span="11">
                <a-form-item
                  :labelCol="labelCol2"
                  :wrapperCol="wrapperCol2"
                  label="开标时间"
                  hasFeedback
                >
                  <a-date-picker
                    :disabled="!isEdit"
                    class="itemWidth"
                    @change="changTime"
                    placeholder="请选择开标日期"
                    v-decorator="['openingTime', { rules: [{ required: true, message: '请选择开标日期！' }] }]"
                  />
                </a-form-item>
              </a-col>
            </div>
            <a-col :span="11">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="中标单位" hasFeedback>
                <a-select
                  :allowClear="true"
                  class="itemWidth"
                  placeholder="请选择中标单位"
                  :disabled="!isEdit"
                  v-decorator="['winningCompany', { rules: [{ required: true, message: '请选择中标单位！' }] }]"
                >
                  <a-select-option
                    v-for="(item,index) in businessList"
                    :value="item.id"
                    :key="index"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="中标金额">
                <a-input
                  placeholder="请输入中标金额"
                  autocomplete="off"
                  addon-after="元"
                  :disabled="!isEdit"
                  v-decorator="['winningPrice', { rules: [{ required: false, message: '请输入中标金额！' }] }]"
                />
              </a-form-item>
            </a-col>
            <div v-if="type === 'MODAL_MODIFY'">
              <a-col :span="11">
                <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="投标金额">
                  <a-input
                    placeholder="请输入投标金额"
                    autocomplete="off"
                    addon-after="元"
                    :disabled="!isEdit"
                    v-decorator="['tenderPrice', { rules: [{ required: true, message: '请输入投标金额！' }] }]"
                  />
                </a-form-item>
              </a-col>
            </div>
          </div>
          <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="业主联系人" hasFeedback>
              <a-select
                :allowClear="true"
                class="itemWidth"
                placeholder="请选择联系人"
                :disabled="!isEdit"
                v-decorator="['contactId', { rules: [{ required: true, message: '请选择联系人！' }] }]"
              >
                <a-select-option
                  v-for="(item,index) in proprietorContactsList"
                  :value="item.id"
                  :key="index"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="22">
            <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文件上传">
              <uploader
                ref="uploader"
                v-if="isEdit"
                :showUploadList="false"
                @handleUpload="handleUpload"
              ></uploader>
              <div v-for="item in fileList" :key="item.id" class="downloadFileList">
                <p>
                  {{ item.fileName }}
                  <a-icon type="download" v-if="item.id" @click="handleDownload(item)" />
                  <a-icon type="eye" v-if="item.id" @click="handlePreview(item)" />
                  <a-popconfirm
                    :title="'你确定要删除“' + item.fileName + '”吗?'"
                    @confirm="handleDeleteFile(item)"
                    v-if="type !== 'MODAL_VIEW'"
                  >
                    <a-icon type="delete" />
                  </a-popconfirm>
                </p>
              </div>
            </a-form-item> -->
            <a-form-item v-if="isEdit" :labelCol="labelCol" :wrapperCol="wrapperCol" label="文件上传">
              <zm-upload
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                @handleUpload="handleUpload"
              ></zm-upload>
            </a-form-item>
          </a-col>

          <!-- <a-col :span="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="市场跟进人" hasFeedback>
              <a-input  id="trackerId" class="itemWidth" :disabled="true" />
            </a-form-item>
          </a-col>-->
          <!--          <a-col :span="24">-->
          <!--            <a-form-item-->
          <!--              :labelCol="labelCol"-->
          <!--              :wrapperCol="wrapperCol"-->
          <!--              label="附件上传"-->
          <!--              hasFeedback-->
          <!--            >-->
          <!--              <a-upload-->
          <!--                name="file"-->
          <!--                :multiple="true"-->
          <!--                :action="uploadAction"-->
          <!--                :headers="headers"-->
          <!--                @change="handleChange"-->
          <!--              >-->
          <!--                <a-button>-->
          <!--                  <a-icon type="upload"/>-->
          <!--                  上传文件-->
          <!--                </a-button>-->
          <!--              </a-upload>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :span="24" style="text-align: right">
            <a-button
              type="primary"
              html-type="submit"
              style="margin-right:10px;"
              v-if="this.type !== this.$sysInfo.MODAL_VIEW"
            >提交</a-button>
            <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import { getContactsById } from '@/api/contacts.js'
// import Uploader from '@/CrComponents/Uploader'
import baseModal from '@/CrComponents/Modal/Modal.vue'
import moment from 'moment'
// import { downLoadFile } from '@/api/download'
import { insertFollows, updateFollows } from '@/api/follows'
import { getFriendBusinessList } from '@/api/friendBusiness'

export default {
  name: 'EditFollows',
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    statusList () {
      return this.$store.state.market.statusList
    },
    marketModel () {
      return this.$store.state.market.marketModel
    },
    proprietorId () {
      return this.$store.state.market.proprietorId
    }
  },
  components: {
    baseModal,
    // Uploader
  },
  watch: {
    proprietorId (newVal) {
      if (newVal) {
        this.initContacts()
      }
    }
  },
  data () {
    return {
      businessList: [],
      proprietorContactsList: [], // 业主联系人列表
      files: [],
      uploadAction: this.$sysInfo.apiRemote + '/upload/tmp/file',
      headers: {
        Authorization: this.$store.state.user.token
      },
      title: '操作',
      width: 1200,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'follows' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      contactList: [],
      fileList: [],
      isStatus: null
    }
  },
  methods: {
    initContacts () {
      getContactsById(this.proprietorId).then((res) => {
        if (res.status === 0) {
          this.proprietorContactsList = res.data
        }
      })
      getFriendBusinessList({ status: 1, paging: false }).then((res) => {
        if (res.status === 0) {
          this.businessList = res.data
        }
      })
    },
    changTime () {},
    // 状态改变时
    changStatus (val) {
      console.log('val', val)
      if (val) {
        this.isStatus = val
      }
    },
    // 上传文件
    handleChange (info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        const response = info.file.response
        if (response.status === 0) {
          this.files.push({
            fileName: info.file.name,
            filePath: response.data[0]
          })
        }
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if (flag) {
        if (this.type !== this.$sysInfo.MODAL_ADD) {
          this.getModelInfo()
        } else {
          this.formClear()
          this.$nextTick(() => {
            const status = 'MARKET_STATUS_01'
            this.form.setFieldsValue({
              status: status
            })
          })
        }
      }
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          params.marketId = this.marketModel.id
          if (this.fileList.length) params.files = this.fileList
          if (this.type === this.$sysInfo.MODAL_ADD) {
            insertFollows(params).then((res) => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            updateFollows(params).then((res) => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      const data = this.model
      console.log(data)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          info: this.model.info,
          remark: this.model.remark,
          contactId: this.model.contactId,
          trackerId: this.model.trackerId,
          traceTime: moment(this.model.traceTime, 'YYYY-MM-DD').utc(8),
          status: this.model.status
        })
        this.isStatus = this.model.status
        this.$nextTick(() => {
          if (this.isStatus === 'MARKET_STATUS_02') {
            this.form.setFieldsValue({
              winningTime: moment(this.model.winningTime, 'YYYY-MM-DD').utc(8),
              winningPrice: this.model.winningPrice,
              tenderPrice: this.model.tenderPrice
            })
          }
          if (this.isStatus === 'MARKET_STATUS_03') {
            this.form.setFieldsValue({
              winningCompany: this.model.winningCompany,
              winningPrice: this.model.winningPrice,
              tenderPrice: this.model.tenderPrice
            })
          }
        })
      })
      this.fileList = [...this.model.files]
    },
    // 清空表单
    formClear () {
      console.log('清空和数据')
      this.fileList = []
      this.model = {}
      this.isStatus = null
      this.$nextTick(() => {
        this.form.resetFields()
      })
      if (this.$refs.uploader) this.$refs.uploader.clearFileList()
      // setTimeout(() => {
      //   this.$refs.uploader.clearFileList()
      // })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    handleUpload (fileList) {
      this.fileList = fileList
      // fileList.map((item) => {
      //   this.fileList.push(item)
      // })

      // this.$refs.uploader.clearFileList()
    },
    // // 删除文件
    // handleDeleteFile (file) {
    //   const dataSource = [...this.fileList]
    //   this.fileList = dataSource.filter((item) => item.filePath !== file.filePath)
    // },
    // handleDownload (item) {
    //   console.log('item', item)
    //   var urlPath = '/opt/pms/back/dataSystem/marketFollow/' + item.filePath
    //   // return
    //   downLoadFile(urlPath).then((res) => {
    //     const blob = new Blob([res])
    //     const downloadElement = document.createElement('a') // 创建下载的链接
    //     const href = window.URL.createObjectURL(blob)
    //     downloadElement.href = href
    //     downloadElement.download = item.fileName // 下载后的文件名
    //     document.body.appendChild(downloadElement)
    //     downloadElement.click() // 下载
    //     document.body.removeChild(downloadElement) // 下载完成 移除 a
    //     window.URL.revokeObjectURL(href) // 释放blob对象
    //   })
    // },
    // handlePreview (item) {
    //   console.log('预览', item)
    //   var filePath = '/opt/pms/back/dataSystem/marketFollow/' + item.filePath
    //   window.open(
    //     `${this.$sysInfo.previewUrl}` +
    //       filePath +
    //       `&fileName=${item.filePath}` +
    //       `&account=${this.$store.state.user.info.account}` +
    //       `&token=${this.$store.state.user.info.token}` +
    //       '&jwtToken=' +
    //       this.$store.state.user.token
    //   )
    // }
  },
  mounted () {
    console.log('状态', this.type)

    this.initContacts()
  }
}
</script>

<style scoped>
.itemWidth {
  width: 256px;
}
</style>
